import { FC, useCallback } from 'react';

import SelectBase, { SelectBaseProps } from 'components/SelectBase';

import { useFilter } from 'lib';
import { SelectChangeEvent } from '@mui/material/Select';

type Props = Omit<SelectBaseProps, 'options'>;

type Option = {
  value?: '0' | '1' | '';
  label: string;
};

const options: Option[] = [
  {
    value: '',
    label: 'Rodyti visus',
  },
  {
    value: '0',
    label: 'Aktyvus',
  },
  {
    value: '1',
    label: 'Pasibaigęs galiojimas',
  },
];

const FlightStatusFilter: FC<Props> = props => {
  const [value, setValue] = useFilter('expired');

  const handleChange = useCallback(
    (event: SelectChangeEvent) => {
      setValue(event.target.value);
    },
    [setValue]
  );

  return (
    <SelectBase
      autoWidth
      options={options}
      value={value ?? ''}
      onChange={handleChange}
      placeholder="Skrydžio būklė"
      label="Skrydžio būklė"
      {...props}
    />
  );
};

export default FlightStatusFilter;
